import React, { useState, useEffect, useContext } from 'react';


import SimpleTable from '../../components/tables/simpleTable';

import RecoverModal from '../../components/modals/recoverModal';
import AddModal from '../../components/modals/addModal';
import EditModal from '../../components/modals/editModal';
import DeleteModal from '../../components/modals/deleteModal';
import CartModal from '../../components/modals/cartModal';

import SearchFilter from '../../components/filters/search';
import CustomButton from '../../components/buttons/customButton';
import IsActiveFilter from '../../components/filters/isActive';
import AddButton from '../../components/buttons/addButton';
import DataFilter from '../../components/filters/dataFilter';
import DatePicker from '../../components/filters/datePicker';
import DropDownFilter from '../../components/filters/dropDownFilter';


import { FcKindle } from "react-icons/fc";

import Loader from '../../components/loader/loader';
import { numberFormatter, totalFormatter, decimalFormatter } from '../../components/formatters/numberFormatter';
import { dateFormatter } from '../../dynamic/dateFormatter';
import { typeFormatter, paymentTypeFormatter } from '../../components/formatters/defFormatter';
import { clientOrderColumnDefs } from '../../components/tables/columnDefs';
import { dateTableFormatter } from '../../dynamic/dateFormatter';
import { creditFormatter, debitFormatter } from '../../components/formatters/defFormatter';
import toast from 'react-hot-toast';

import { Space, Input, Tag, Button, Tabs } from 'antd';

import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcRefresh, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiBarcodeReader } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../init/getData';




function SalesInvoice(props) {

  let { type, isOut } = props;


  const { api, userData, settingData, refProductData, productData, accountData, refAccountData, refWareHouseData, wareHouseData, devData } = useContext(DataContext);
  const userRole = userData.role;
  const [loadingCounter, setLoadingCounter] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);
  const defaultWareHouseId = userData?.role?.defaultWareHouseId;


  useEffect(() => {
    const fetchData = async () => {
      try {
        await refProductData();
        await refAccountData();
        await refWareHouseData();
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);

  const table = 'transaction';
  const title = type;

  const inStockProducts = productData;
  const accountDataType = accountData?.filter(account => account.type === 'Customer');


  // Product Options
  const productOptions = inStockProducts?.map(item => ({
    value: item.id,
    label: `${item.sku ? ` (${item.sku}) ` : ''}  ${item.name} ${item.barcode ? ` [${item.barcode}]` : ''}`,
    id: item.id,
    category: item.category.name,
    productId: item.id,
    type: item.type,
    name: item.name,
    barcode: item.barcode,
    cost: item.cost,
    price: item.price,
    isStock: item.isStock,
    stock: item.totalStock,
    units: item.units,
    unit: item.unit,
  }))

  const filterProducts = (inputValue, options) => {
    return options.filter(option =>
      option.label.toLowerCase().includes(inputValue.toLowerCase())
    );
  };

  const loadProductOptions = (inputValue, callback) => {
      if (inputValue) {
        callback(filterProducts(inputValue, productOptions));
      } else {
        callback([]);
      }
  };


  // Supplier Options
  const supplierOptions = accountDataType?.map(item => ({
    value: item.id,
    label: `${item.name} [${item.phone}]`,
  }))

  // WareHouse Options
  const wareHouseOptions = wareHouseData?.map(item => ({
    value: item.id,
    label: item.name,
  }))

  const today = new Date().toISOString().split('T')[0];

  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);
  const [filter, setFilter] = useState({ search: '', isActive: 'true', fromDate: today, toDate: today, wareHouseId: defaultWareHouseId });

  //change Type
  useEffect(() => {
    setFilter(prevFilter => ({ ...prevFilter, type: type, isOut: isOut }));
  }, [type]);

  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showCartModal, setShowCartModal] = useState(false);

  const [supplier, setSupplier] = useState([]);
  const [wareHouse, setWareHouse] = useState([]);
  const [transaction, setTransaction] = useState({});

  const [cart, setCart] = useState([]);

  const cartItem = {
    productId: '',
    category: '',
    barcode: '',
    name: '',
    quantity: 1,
    price: 0,
    netPrice: 0,
    totalPrice: 0,
    cost: 0,
    isStock: true,
    type: '',
    serial: '',
    units: JSON.stringify([]),
    unit: '',
    unitFormula: 1,
    unitQuantity: 1,
    details: '',
  };


  // idRow Change
  useEffect(() => {
    const supplierId = supplierOptions.find(option => option.value === idRow?.accountId) || [];
    setSupplier(supplierId);

    const wareHouseId = wareHouseOptions.find(option => option.value === idRow?.wareHouseId) || [];
    setWareHouse(wareHouseId);

    setCart(idRow?.cart || [cartItem])

    setTransaction(
      {
        createdBy: createdBy,
        accountId: idRow?.accountId || [],
        wareHouseId: idRow?.wareHouseId || [],
        refNumber: idRow?.refNumber || '',
        date: idRow?.date || today,
        isOut: isOut,
        isCredit: idRow?.isCredit || false,
     
        type: type,
        total: idRow?.total || 0,
        details: idRow?.details || '',
        discount: idRow?.discount || 0,
      }
    )
  }, [idRow]);


  // Add new row
  const handleAddRow = () => {
    setCart([...cart, cartItem]);
  };

  // Delete VarientRow
  const handleDeleteRow = (event) => {
    event.preventDefault()
    if (cart.length > 1) {
      const updatedRows = cart.slice(0, -1);
      setCart(updatedRows);
    } else {
      toast.error('you need at least one item')
    }
  };

  // handle row changes
  const handleRowChange = (index, value, field) => {
    const updatedCart = [...cart];


    if (field == 'product') {
      updatedCart[index].productId = value.id;
      updatedCart[index].name = value.name;
      updatedCart[index].barcode = value.barcode;
      updatedCart[index].cost = parseFloat(value.cost);
      updatedCart[index].price = parseFloat(value.price);
      updatedCart[index].netPrice = parseFloat(value.price);
      updatedCart[index].category = value.category;
      updatedCart[index].type = value.type;
      updatedCart[index].unit = value.unit;
      updatedCart[index].units = JSON.stringify(value.units);
      updatedCart[index].unitFormula = 1;
      updatedCart[index].unitQuantity = 1;
      updatedCart[index].isStock = value.isStock;

    } else if (field == 'price') {

      updatedCart[index].price = parseFloat(value);
      updatedCart[index].netPrice = parseFloat(value);

    } else if (field == 'quantity') {
      updatedCart[index].quantity = parseFloat(value);

    } else if (field == 'unitFormula') {
      updatedCart[index].unitFormula = parseFloat(value);

    } else if (field == 'unitQuantity') {
      updatedCart[index].unitQuantity = parseFloat(value);

    } else if (field == 'details') {
      updatedCart[index].details = value;

    } else if (field == 'serial') {
      updatedCart[index].serial = value;
    }


    if (settingData.showSecondaryUnit) {
      updatedCart[index].quantity = updatedCart[index].unitFormula * updatedCart[index].unitQuantity;
    }

    updatedCart[index].totalPrice = decimalFormatter(updatedCart[index].price * updatedCart[index].quantity, 2);

    setCart(updatedCart);
  }


  // calculate Total
  useEffect(() => {
    let discount;
    const total = cart.reduce((acc, item) => acc += parseFloat(item.totalPrice), 0);
    if (transaction.discount) {
      discount = decimalFormatter(total - (total * transaction.discount / 100), 2)
    } else {
      discount = total;
    }

    setTransaction((prev) => ({
      ...prev,
      total: discount,
    }));
  }, [cart, transaction.discount]);


  const addModal = () => {
    setIdRow([]);
    resetForm();
    setShowAddModal(!showAddModal);
  }

  const cartModal = (e) => {
    if (!showCartModal) {
      setIdRow(e);
    }
    setShowCartModal(!showCartModal);
  }

  const recoverModal = (e) => {
    if (!showRecoverModal) {
      setIdRow(e);
    }
    setShowRecoverModal(!showRecoverModal);
  }

  const deleteModal = (e) => {
    if (!showDeleteModal) {
      setIdRow(e);
    }
    setShowDeleteModal(!showDeleteModal);
  }

  const editModal = (e) => {
    if (!showEditModal) {
      setIdRow(e);
    }
    setShowEditModal(!showEditModal);
  }


  const resetForm = () => {
    setIdRow([]);
    setSupplier([]);
    setWareHouse([]);
    setCart([cartItem]);
  }

  // handle select change
  const handleSelectChange = (selectedOption, name) => {
    if (name == 'accountId') {
      setSupplier(selectedOption)
    } else if (name == 'wareHouseId') {
      setWareHouse(selectedOption)
    }
    
    setTransaction((prev) => ({
      ...prev,
      [name]: selectedOption.value,
    }));
  };

  // Generic handler for input changes
  const handleInputChange = (e, type) => {
    let { name, value } = e.target;
    if (type == 'number') {
      value = parseFloat(value)
    } else if (type == 'boolean') {
      value = JSON.parse(value)
    }
    setTransaction((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  //Excel Data
  const getExcelData = (data) => {

    const transformedData = [];
    data.forEach(item => {

      const newItem = {
        id: item.id,
        refNumber: item.refNumber,
        createdAt: item.createdAt,
        account: item.account?.name,
        delivery: item.delivery?.name,
        total: item.total,
        discount: item.discount,
        type: item.type,
        isCredit: item.isCredit,
     
        details: item.details,
      };

      transformedData.push(newItem);
    });

    return { transformedData };
  };

  let newColumnDefs = [
    { title: 'ID', dataIndex: 'id', width: '6%', sorter: (a, b) => a.age - b.age },
    { title: 'Ref#', dataIndex: 'refNumber', width: '6%' },
    { title: 'CreatedAt', dataIndex: 'createdAt', render: dateTableFormatter },
    { title: 'Date', dataIndex: 'date' },
    { title: 'Account', dataIndex: 'account', render: (account) => (account?.name) },
    { title: 'Total In', dataIndex: 'total', width: '8%', render: debitFormatter },
    { title: 'Total Out', dataIndex: 'total', width: '8%', render: creditFormatter },
    { title: 'Discount %', dataIndex: 'discount', width: '8%', render: numberFormatter },
    { title: 'Payment', dataIndex: 'isCredit', render: paymentTypeFormatter },
  ];

  useEffect(() => {

    if (filter.isActive == 'true') {
      newColumnDefs.push(
        {
          title: 'View',
          width: '5%',
          render: (_, record) => (
            <FcKindle size={18} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => cartModal(record)} />
          ),
        },
        {
          title: 'Edt',
          width: '5%',
          render: (_, record) => (
            <FiEdit size={16} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => editModal(record)} />
          ),
        },
        {
          title: 'Del',
          width: '5%',
          render: (_, record) => (
            <BiSolidTrash size={18} style={{ cursor: 'pointer', color: '#e6434f' }} onClick={() => deleteModal(record)} />
          ),
        }
      );
    } else {
      newColumnDefs.push(
        {
                title: 'Deleted At',
                dataIndex: 'deletedAt',
                render: dateTableFormatter,
              },
        {
        title: 'Rec',
        width: '3%',
        render: (_, record) => (
          <FcUndo size={20} style={{ cursor: 'pointer' }} onClick={() => recoverModal(record)} />
        ),
      });
    }
    setColumnDefs(newColumnDefs);

  }, [filter.isActive]);

  const formView = (
    <div style={{ userSelect: 'none' }}>
      <>

        <Row className="mb-3" >

          {/* Supplier */}
          <Form.Group as={Col}>
            <Form.Label className='formLabel'>Customer<span style={{ color: 'red' }}> *</span></Form.Label>
            <Select
              options={supplierOptions}
              isSearchable={true}
              placeholder="Select"
              onChange={(e) => handleSelectChange(e, 'accountId')}
              value={supplier}
              required
            />
          </Form.Group>

          {/* Date */}
          <Form.Group as={Col}>
            <Form.Label className='formLabel'>Date<span style={{ color: 'red' }}> *</span></Form.Label>
            <input type="date" className="form-control" name='date'
              onChange={(e) => handleInputChange(e, 'text')}
              value={transaction.date}
              required
            ></input>
          </Form.Group>


          {/* ID Number */}
          <Form.Group as={Col}>
            <Form.Label className='formLabel'>Reference #</Form.Label>
            <input type="text" className="form-control" placeholder='Optional' name='refNumber'
              onChange={(e) => handleInputChange(e, 'text')}
              value={transaction.refNumber}
            ></input>
          </Form.Group>

          {/* WareHouse */}
          <Form.Group as={Col}>
            <Form.Label className='formLabel'>WareHouse<span style={{ color: 'red' }}> *</span></Form.Label>
            <Select
              options={wareHouseOptions}
              isSearchable={true}
              placeholder="Select"
              onChange={(e) => handleSelectChange(e, 'wareHouseId')}
              value={wareHouse}
              required
            />
          </Form.Group>

          {/* Payment */}
          <Form.Group as={Col}>
            <Form.Label className='formLabel'>Payment<span style={{ color: 'red' }}> *</span></Form.Label>
            <select name="isCredit" className="form-control"
              onChange={(e) => handleInputChange(e, 'boolean')}
              value={transaction.isCredit}>
              <option value='false' >Cash</option>
              <option value='true'>Credit</option>
            </select>
          </Form.Group>

          

        </Row>


        {/* Cart Array  */}
        <div>
          {cart.map((row, index) => (
            <div key={index} style={{ marginTop: '2%' }}>
              {/* Labels */}
              {index === 0 && (
                <Row className="mb-3">
                  <Form.Group as={Col} md={3}>
                    <Form.Label>Select Products</Form.Label>

                    <FcRefresh size={20} onClick={refProductData}
                      style={{ cursor: 'pointer', marginLeft: '5' }} />
                  </Form.Group>


                  {settingData.serializedProduct &&
                    <>
                      <Form.Group as={Col} >
                        <Form.Label>Serial #</Form.Label>
                      </Form.Group>
                    </>
                  }


                  {(settingData.showSecondaryUnit && cart[index].type != 'serialized') &&
                    <>
                      <Form.Group as={Col} >
                        <Form.Label>unit</Form.Label>
                      </Form.Group>

                      <Form.Group as={Col}   >
                        <Form.Label>Unit Quantity</Form.Label>
                      </Form.Group>
                    </>
                  }

                  <Form.Group as={Col}   >
                    <Form.Label>Quantity</Form.Label>
                  </Form.Group>

                  <Form.Group as={Col} >
                    <Form.Label>Unit Price</Form.Label>
                  </Form.Group>


                  <Form.Group as={Col} >
                    <Form.Label>Cost</Form.Label>
                  </Form.Group>


                  <Form.Group as={Col} >
                    <Form.Label>Price</Form.Label>
                  </Form.Group>


                  <Form.Group as={Col} md={2}>
                    <Form.Label>Details</Form.Label>
                  </Form.Group>

                </Row>

              )}

              {/* Products */}
              <Row className="mb-3" style={{ marginTop: '-20px' }}>
                <Form.Group as={Col} md={3}>
                  <AsyncSelect
                    cacheOptions
                    loadOptions={loadProductOptions}
                    defaultOptions={[]}
                    onChange={(e) => handleRowChange(index, e, 'product')}
                    value={productOptions.find(option => option.value === cart[index].productId) || []}
                    noOptionsMessage={() => 'type to view'}
                    required
                  />
                </Form.Group>




                {/* Serial number */}
                {settingData.serializedProduct &&
                  <Form.Group as={Col} >
                    <Form.Control type="text"
                      onChange={(e) => handleRowChange(index, e.target.value, 'serial')}
                      value={cart[index].serial}
                      disabled={cart[index].type !== 'serialized'}
                      required />
                  </Form.Group>
                }


                {/* Secondary Units  */}
                {(settingData.showSecondaryUnit && cart[index].type != 'serialized') &&
                  <>
                    <Form.Group as={Col} >
                      <select className="form-control" name='unitFormula'
                        value={cart[index].unitFormula}
                        onChange={(e) => handleRowChange(index, e.target.value, 'unitFormula')}>
                        <option value={1}>{cart[index].unit} (x1)</option>
                        {(cart[index]?.units ? JSON.parse(cart[index].units) : []).map((unit, unitIndex) => (
                          <option key={index} value={unit.value}>{unit.unit} (x{unit.value})</option>
                        ))}

                      </select>
                    </Form.Group>

                    {/*  Units Quantity  */}
                    <Form.Group as={Col} >
                      <Form.Control type="number" min={0} step='any'
                        onChange={(e) => handleRowChange(index, e.target.value, 'unitQuantity')}
                        value={cart[index].unitQuantity}
                        required
                      />
                    </Form.Group>

                    {/* Quantity by Unit  */}
                    <Form.Group as={Col} >
                      <Form.Control type="number" min={0} step='any' disabled readOnly
                        value={cart[index].quantity} />
                    </Form.Group>

                  </>
                }



                {/* Quantity Type Simple */}
                {(!settingData.showSecondaryUnit || cart[index].type == 'serialized') &&
                  <Form.Group as={Col} >
                    <Form.Control type="number" min={0} step='any'
                      onChange={(e) => handleRowChange(index, e.target.value, 'quantity')}
                      value={cart[index].quantity}
                      required />
                  </Form.Group>
                }


                {/* Serial Quantity */}
                {row.productType == 'serialized' &&
                  <Form.Group as={Col} >
                    <Form.Control type="number" min={0} step='any'
                      disabled
                    />
                    <FcPlus size={20} style={{ cursor: 'pointer', marginLeft: '40px' }} />
                    <HiMinusCircle size={22} style={{ cursor: 'pointer' }} />
                  </Form.Group>
                }



                {/* Price */}
                <Form.Group as={Col} >
                  <Form.Control type="number" min={0} step='any' value={cart[index].price}
                    onChange={(e) => handleRowChange(index, e.target.value, 'price')}
                    required
                  />
                </Form.Group>


                {/* Cost */}
                <Form.Group as={Col} >
                  <Form.Control type="number" min={0} step='any' value={cart[index].quantity * cart[index].cost}
                    onChange={(e) => handleRowChange(index, e.target.value, 'price')}
                    disabled
                  />
                </Form.Group>


                {/* total */}
                <Form.Group as={Col}  >
                  <Form.Control type="number" name="total" id="total"
                    value={cart[index].totalPrice}
                    disabled />
                </Form.Group>


                {/* Details */}
                <Form.Group as={Col} md={2}>
                  <Form.Control as="textarea" rows={1}
                    value={cart[index].details}
                    onChange={(e) => handleRowChange(index, e.target.value, 'details')}
                  />
                </Form.Group>

              </Row>



              <Row key={index + 100} className="mb-3">
                {index === cart.length - 1 && (
                  <Form.Group
                    as={Col}
                    style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '30px' }}
                  >
                    <FcPlus size={26} style={{ cursor: 'pointer' }} onClick={handleAddRow} />
                    <HiMinusCircle size={28} style={{ cursor: 'pointer' }} onClick={(e) => handleDeleteRow(e)} />

                  </Form.Group>
                )}
              </Row>
            </div>
          ))}
        </div>

        {/* Discount*/}
        <Row className="mb-3" style={{ textAlign: 'center' }}>
          <Form.Group as={Col} className="mx-auto" md={3} >
            <Form.Label>Discount %</Form.Label>
            <input style={{ textAlign: 'center' }} type='number' name='discount' className="form-control"
              value={transaction.discount}
              onChange={(e) => handleInputChange(e, 'number')}
              required />
          </Form.Group>
        </Row>



        <Row className="mb-3" style={{ marginTop: '2%', textAlign: 'center' }}>
          <Form.Group as={Col}>
            <Form.Label>Details</Form.Label>
            <textarea className="form-control"
              value={transaction.details} name='details'
              onChange={(e) => handleInputChange(e, 'text')}
            ></textarea>
          </Form.Group>

        </Row>



      </>


    </div>
  )

  const tableFooter = (
    <></>
  )

  const modalFooter = (
    <div>

      <a style={{ fontWeight: 'bold' }}>
        SalesInvoice
      </a>

      <a style={{ color: 'green', fontWeight: 'bold', fontSize: '25px', marginLeft: 100 }}>
        {numberFormatter(transaction.total, 2)}{settingData.currency}
      </a>

    </div>
  )

  return (
    <div className='card'>

      <div>

        <SearchFilter setFilter={setFilter} />
        <DatePicker setFilter={setFilter} filter={filter} />
        <AddButton addModal={addModal} />

        <DropDownFilter setFilter={setFilter} filterBy={'wareHouseId'} placeHolder={'All ' + devData.wareHouseName} filter={filter} setLoadingCounter={() => setLoadingCounter((prevCounter) => prevCounter + 1)} />

      </div>


      {(isLoading || loadingCounter < 1) &&
        <Loader />
      }


      {(!isLoading && loadingCounter == 1) &&
        <>
          <div>

          </div>



          <SimpleTable
            filter={filter}
            showAddModal={showAddModal}
            addModal={addModal}
            table={table}
            title={title}
            columnDefs={columnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            refreshTable={refreshTable}
            data={data}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
            selection={true}
          />

          <DeleteModal
            showModal={showDeleteModal}
            toggleModal={deleteModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
            data={{ transactionId: idRow?.id, cart, transaction: transaction }}
          />

          <CartModal
            showModal={showCartModal}
            toggleModal={cartModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
          />

          <RecoverModal
            showModal={showRecoverModal}
            toggleModal={recoverModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
          />

          <AddModal
            showModal={showAddModal}
            toggleModal={addModal}
            formView={formView}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            size={'xxl'}
            resetForm={resetForm}
            footer={modalFooter}
            api={api}
            data={{ cart, transaction: transaction }}
          />

          <EditModal
            showModal={showEditModal}
            toggleModal={editModal}
            formView={formView}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            size={'xxl'}
            footer={modalFooter}
            api={api}
            data={{ transactionId: idRow?.id, cart, transaction: transaction }}
          />


        </>
      }

    </div>
  )
}

export default SalesInvoice;
